import React from "react"

const Footer = () => {
  return (
    <footer>
      <p className="text-center py-3 text-lg font-semibold">
        Created By Zaryab Khalid. @ 12 Oct, 2022
      </p>
    </footer>
  )
}

export default Footer
